import React, { useEffect } from "react";
import { useMap } from "react-leaflet";
import { SLV_CLOSE_SEARCHABLE_SELECT_EVENT } from "../../utils/searchableSelectEvents";

/** Close SearchableSelect when user interacts with the Leaflet map (clicks often don't bubble to document). */
export default function LeafletMapCloseSearchableSelect() {
  const map = useMap();
  useEffect(() => {
    const close = () => window.dispatchEvent(new CustomEvent(SLV_CLOSE_SEARCHABLE_SELECT_EVENT));
    map.on("click", close);
    map.on("mousedown", close);
    map.on("dragstart", close);
    return () => {
      map.off("click", close);
      map.off("mousedown", close);
      map.off("dragstart", close);
    };
  }, [map]);
  return null;
}
